// Breadcrumbs Ellipsis
jQuery.fn.breadcrumbs = function(options) {
    var el = jQuery(this);
    // var breadcrumbsID = document.getElementById("#breadcrumbs-container");
    // var breadcrumbsHeight = breadcrumbsID.offsetHeight;

    // truncate individual titles if over set length
    var crumbCounter = 0;
    jQuery('a', el).each(function() {
        var crumbTitle = jQuery(this).text();
        if (crumbTitle.length > options.crumbMaxLength) {
            jQuery(this).text(
                jQuery.trim(crumbTitle).substring(0, 100).split(" ").slice(0, -1).join(" ") + "....."
            );
        }
        crumbCounter++;
    });

    // remove the link from the current page crumb
    jQuery('.active', el).replaceWith(
        jQuery('<span/>').text(jQuery('.active', el).text())
    );

    var crumbs = jQuery.map(jQuery('a, span', el).toArray(), function(x) {
        return x.outerHTML;
    });

    // Create crumb for the current page
    if (crumbCounter >= 1) {
         var currentPageCrumbString = jQuery(document).attr('title');
         var currentPageCrumb = options.separator + '<span>' + currentPageCrumbString.split('|')[0] + '<span>';
    } else {
        var currentPageCrumb = '';
    }

    // if truncation needed
    // if (breadcrumbsHeight > 30) {
    if (crumbs.length > options.maxLevels) {
        var firstCrumbs = crumbs.slice(0, options.startCrumbs);
        var hideCrumbs = '<a href="#" title="Show all">…</a>';
        var lastCrumbs = crumbs.slice(crumbs.length - options.endCrumbs);
        var newCrumbs = firstCrumbs.concat([hideCrumbs]).concat(lastCrumbs);
        el.html(options.intro + newCrumbs.join(options.separator) + currentPageCrumb);
    } else {
        el.html(options.intro + crumbs.join(options.separator) + currentPageCrumb);
    }

    // show the hidden breadcrumbs when ellipsis is clicked
    jQuery('[title]', el).click(function() {
        el.html(options.intro + crumbs.join(options.separator));
    });
};

jQuery('.breadcrumbs').breadcrumbs({
    intro: '<li class="breadcrumb-home"> </li>',
    separator: '<span class="breadcrumbs-separator"> <i class="fas fa-chevron-right"></i></span>',
    maxLevels: 15,
    startCrumbs: 2,
    endCrumbs: 3,
    crumbMaxLength: 100
});
